import {SaleVehicleLeasingConfiguration, SaveSaleVehicleLeasingBody} from '@dms/api/vehicle';

/** Maps the persisted leasing configuration back into the save body the editor works on. */
export function configurationToLeasingBody(
  configuration: SaleVehicleLeasingConfiguration
): SaveSaleVehicleLeasingBody {
  return {
    financialInstitutionCodeId: configuration.financialInstitutionCodeId,
    targetGroup: configuration.targetGroup,
    primaryTargetGroup: configuration.primaryTargetGroup,
    validFrom: configuration.validFrom,
    validTo: configuration.validTo,
    activeTerm: configuration.activeTerm,
    activeAnnualMileage: configuration.activeAnnualMileage,
    // Copied, not shared: `configuration` is RTK Query cache data. The panel replaces these arrays
    // wholesale on every edit (never mutates a cell or a condition code in place), but holding the
    // cache's own array reference here would still let an in-place mutation elsewhere reach the
    // cache.
    rateMatrixCells: [...configuration.rateMatrixCells],
    commonParameters: {
      ...configuration.commonParameters,
      specialConditionCodes: [...configuration.commonParameters.specialConditionCodes],
    },
  };
}
